/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProductKind {
    Internal = '0',
    Demo = 1,
    Customer = 2,
}
